import React from "react"
import styled from "styled-components"
import { ListItem } from "./ListItem"
import { data } from "../data"

const OrderedList = styled.ol`
  list-style-type: decimal;
  list-style-position: outside;
  padding: 0;
  margin: 0;

  ol {
    list-style: none;
    list-style-position: inside;
    padding-left: 1rem;

    span {
      margin-inline-end: 0.5rem;
    }
  }
`

export default function ContentList() {
  return (
    <OrderedList>
      {data.map((item, index) => (
        <ListItem
          key={index}
          title={item.title}
          content={
            item.itemList ? (
              <>
                {item.content}
                <ol>
                  {item.itemList.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <span>{String.fromCharCode(9312 + subIndex)}</span>
                      {subItem}
                    </li>
                  ))}
                </ol>
              </>
            ) : (
              item.content
            )
          }
          content2={item?.content2 ? item.content2 : null}
        />
      ))}
    </OrderedList>
  )
}
